/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from "react";
import { hitApi } from "../utils/apiCall.js";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import studDefImg from "./assets/default.png";

function StudentDetailsList() {
  const navigate = useNavigate();
  const [fetchedStudentList, setFetchedStudentList] = useState(null);

  console.log("Data ", fetchedStudentList);
  const [branchKeys, setBranchKeys] = useState([]);
  const [classKeys, setClassKeys] = useState([]);
  const [sectionKeys, setSectionKeys] = useState([]);

  const [attendanceData, setAttendanceData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [totalAttendance, setTotalAttendance] = useState({});
  const [isAllAttendance, setIsAllAttendance] = useState(false);

  const date = new Date();
  const formatNumber = (num) => num.toString().padStart(2, "0");
  const [selectedDate, setSelectedDate] = useState(
    `${date.getFullYear()}-${formatNumber(date.getMonth() + 1)}-${formatNumber(
      date.getDate()
    )}`
  );
  const [selectedRow, setSelectedRow] = useState(null);
  const [showNoteModal, setShowNoteModal] = useState(null);
  const [theme] = useState(localStorage.getItem("theme"));
  console.log("", fetchedStudentList);

  // Utility function to fetch and parse local storage
  const getStoredKeys = (key) => {
    const storedData = JSON.parse(localStorage.getItem(key)) || {};
    return Object.keys(storedData)
      .filter((key) => storedData[key])
      .map(Number);
  };

  useEffect(() => {
    setBranchKeys(getStoredKeys("branch-students"));
    setClassKeys(getStoredKeys("class-students"));
    setSectionKeys(getStoredKeys("section-students"));
  }, []);

  // Absent Button
  useEffect(() => {
    if (totalAttendance) {
      const totalCount =
        totalAttendance.totalPresent +
        totalAttendance.totalAbsent +
        totalAttendance.totalLate +
        totalAttendance.totalHalfDay;
      const result = totalCount === totalAttendance.totalStudents;
      setIsAllAttendance(result);
    }
  }, [totalAttendance]);

  // Fetch Attendance Data
  // useEffect(() => {
  //   // if (branchKeys.length && classKeys.length && sectionKeys.length) {
  //   async function getAttendanceList(branch, classes, date, section, search) {
  //     const fd = new FormData();
  //     fd.append("branch[]", branch);
  //     fd.append("classId[]", classes);
  //     fd.append("section[]", section);

  //     fd.append("limit", '10');
  //     fd.append("search", search);
  //     fd.append("date", date);

  //     fd.forEach((v, k) => console.log(k, v));
  //     const res = await hitApi("teacher/attendanceCurl", "getStudentDetails", fd);
  //     console.log(res);
  //     // const res = dummyData
  //     if (res.status === "success") {
  //       const initialAttendance = res?.data?.reduce((acc, student) => {
  //         acc[student.regNo] = student.status || null; // Default to null if no status
  //         return acc;
  //       }, {});
  //       setFetchedStudentList(res.data);
  //       setAttendanceData(initialAttendance);
  //     }
  //   }
  //   getAttendanceList(branchKeys, classKeys, selectedDate, sectionKeys, searchTerm);
  //   // }
  // }, [branchKeys, classKeys, selectedDate, sectionKeys, searchTerm]);

  // API call function wrapped in useCallback to avoid re-creating it

  const fetchOverviewData = useCallback(async () => {
    const fd = new FormData();
    branchKeys.forEach((branch) => fd.append("branch[]", branch));
    classKeys.forEach((classes) => fd.append("class[]", classes));
    sectionKeys.forEach((section) => fd.append("section[]", section));
    fd.append("limit", "10");
    fd.append("status", "1");
    fd.append("date", selectedDate);
    // fd.forEach((v, k) => console.log(k, v));
    try {
      // const res = await hitApi("teacher/attendanceCurl", "getStudentDetailsForView", fd);
      // const res = await hitApi("teacher/attendanceCurl", "getDetails2", fd);
      const res = await hitApi(
        "admission/createAddmissionMain",
        "getStudentDetailsForApp",
        fd
      );

      console.log("Res ", res);
      if (res.success) {
        const initialAttendance = res?.data?.reduce((acc, student) => {
          acc[student.regNo] = student.status || null; // Default to null if no status
          return acc;
        }, {});
        setFetchedStudentList(res.data);
        setAttendanceData(initialAttendance);
      }
    } catch (error) {
      console.error("Error fetching overview data:", error);
      setFetchedStudentList([]);
    }
  }, [branchKeys, classKeys, sectionKeys, selectedDate]);

  useEffect(() => {
    fetchOverviewData();
  }, [fetchOverviewData]);

  // Add Attendance API
  async function addAttendance(regNo, status, enrollId) {
    const fd = new FormData();
    fd.append("branch", branchKeys);
    fd.append("classId", classKeys);
    fd.append("section", sectionKeys);
    fd.append("regNo", regNo);
    fd.append("attendance", status);
    fd.append("enrollId", enrollId);
    fd.append("date", selectedDate);
    const res = await hitApi("teacher/attendanceCurl", "addAttendance", fd);
    console.log(res);

    if (res.success) {
      console.log(`Attendance added for ${regNo} -> ${status}`);
      setAttendanceData((prev) => ({ ...prev, [regNo]: status })); // Update UI
    } else {
      alert("Error adding attendance.");
    }
  }

  // Update Attendance API
  async function updateAttendance(regNo, status, enrollId, attendanceId) {
    const fd = new FormData();
    fd.append("branch", branchKeys);
    // fd.append("classId", classKeys);
    // fd.append("section", sectionKeys);
    // fd.append("regNo", regNo);
    fd.append("attendance", status);
    fd.append("enrollId", enrollId);
    fd.append("id", attendanceId);
    fd.append("date", selectedDate);
    const res = await hitApi("teacher/attendanceCurl", "updateAttendance", fd);

    if (res.success) {
      console.log(`Attendance updated for ${regNo} -> ${status}`);
      setAttendanceData((prev) => ({ ...prev, [regNo]: status })); // Update UI
    } else {
      alert("Error updating attendance.");
    }
  }

  // Handle Attendance Change (Decide whether to Add or Update)
  function handleAttendanceChange(regNo, status, enrollId, attendanceId) {
    if (attendanceData[regNo] === null) {
      addAttendance(regNo, status, enrollId); // Add new attendance
    } else {
      updateAttendance(regNo, status, enrollId, attendanceId); // Update existing attendance
    }
  }

  // For Overall attendance
  useEffect(() => {
    const fd = new FormData();
    fd.append("branch", branchKeys);
    fd.append("classId", classKeys);
    fd.append("section", sectionKeys);
    fd.append("limit", "20");
    // fd.append("date", '2025-02-01');
    async function fetchData() {
      try {
        const res = await hitApi("teacher/attendanceCurl", "getCount", fd);
        setTotalAttendance(res.summary);
      } catch (error) {
        setTotalAttendance({});
        console.error(error);
      }
    }
    fetchData();
  }, [branchKeys, classKeys, sectionKeys, attendanceData]);

  // Add Note Function
  async function handleAddNote(e) {
    e.preventDefault();
    const fd = new FormData(e.target);
    const res = await hitApi("teacher/attendanceCurl", "addNoteForStudent", fd);
    if (res.success) {
      toast.success(res.data);
      setShowNoteModal(false);
    } else {
      toast.success(res.data);
      setShowNoteModal(false);
    }
  }

  return (
    <div className="page-content-wrapper mt-0">
      <div className="position-fixed top-0 start-0 w-100 z-1 shadow-sm">
        {/* Header */}
        <div className="bg-white py-1 px-1" id="headerArea">
          <div className="container">
            {/* Header Content */}
            <div className="d-flex align-items-center pt-2 justify-content-between">
              <div className="d-flex">
                <Link onClick={() => navigate(-1)} className="btn p-0">
                  <small>
                    <i
                      class={`fa fa-arrow-left fa-2x ${theme === "dark" ? "text-light" : "text-dark"
                        }`}
                      aria-hidden="true"
                    ></i>
                  </small>
                </Link>
              </div>
              <div className="d-flex">
                <h2 className="m-0">Student</h2>
              </div>
              <div className="d-flex">
                <Link to="/home" style={{ fontSize: "12px" }}>
                  <small>
                    <i
                      className={`bi bi-house text-white ${theme === "dark" ? "text-light" : "text-dark"
                        }`}
                      style={{ fontSize: "24px" }}
                    ></i>
                  </small>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Student Search and Date */}
        <div
          className="bg-white py-2 px-1 d-flex justify-content-center align-items-center"
          id="headerArea"
        >
          <div className="container row ps-3 pe-3">
            <div className="form-group col-12 px-0 d-flex justify-content-center align-items-center m-0">
              <label htmlFor="" className="form-label"></label>
              <input
  onChange={(e) => {
    setSearchTerm(e.target.value);
  }}
  type="text"
  placeholder="Search by Name, Mobile or Register No"
  className="form-control rounded-3 py-2 h-100"
/>
            </div>
          </div>
        </div>
      </div>
      {/* Attendance  */}
      <div
        className="container p-2 scroll-y-auto"
        style={{
          marginTop: "6.5rem",
          maxHeight: "85vh",
          overflow: "hidden",
          overflowY: "auto",
        }}
      >
        {fetchedStudentList ? (
          fetchedStudentList
            .filter((student) => {
              const search = searchTerm?.toLowerCase()?.trim();

              return (
                student.first_name?.toLowerCase()?.includes(search) ||
                student.father_name?.toLowerCase()?.includes(search) ||
                student.last_name?.toLowerCase()?.includes(search) ||
                student.mobileno?.toLowerCase()?.includes(search) ||
                student.register_no?.toLowerCase()?.includes(search)
              );
            })
            .map((ele, idx) => {
              return (
                <Link
                  // to={`/student-details/exam-details/${ele.id}/${ele.enrollId}`}
                  to={`/student-details/particlar-student-details/${ele.id}/${ele.enrollId}`}
                  key={idx}
                  className={`card  rounded-4 px-2 py-1 mb-2 shadow-sm`}
                >
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div className="me-2">
                        {ele?.photo ? (
                          <img
                            src={ele?.photo}
                            class="img-thumbnail mx-auto d-block"
                            alt="Student Profile Pic"
                            width={90}
                          ></img>
                        ) : (
                          <img
                            src={studDefImg}
                            class="img-thumbnail mx-auto d-block"
                            alt="Student Profile Pic"
                            width={90}
                          ></img>
                        )}
                      </div>
                      <div>
                        <span className="m-0 d-flex justify-content-between">
                          <p className="fw-bold" style={{ marginBottom: "3px" }}>
                            {ele.first_name}{" "}
                            {ele.lastName && ele.lastName !== "."
                              ? ele.lastName
                              : ""}{" "}
                            {ele?.gender === "female" ? "D/O" : "S/O"}{" "}
                            {ele?.father_name}{" "}
                          </p>
                        </span>
                        <span className="m-0 d-flex justify-content-between ">
                          <p className="text-dark-subtle" style={{ fontSize: "13px", margin: "0" }}>
                            {ele.register_no}  {ele?.className} ({ele?.sectionName})
                          </p>
                        </span>
                        <span className="m-0 d-flex justify-content-between ">
                          <p className="text-dark-subtle" style={{ fontSize: "13px", margin: "0" }}>
                            {ele.mobileno}
                          </p>
                        </span>

                        <span className="m-0 d-flex justify-content-between ">
                          <p className="" style={{ fontSize: "11px" }}>{ele.branchName}</p>
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              );
            })
        ) : (
          // Placeholders
          <>
            <div className="card mb-2" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                  <span className="placeholder col-6 rounded-2"></span>
                  <span className="placeholder col-5 rounded-2"></span>
                </h5>
                <p className="card-text d-flex justify-content-between placeholder-glow">
                  <span className="placeholder col-12 py-2 rounded-2"></span>
                </p>
              </div>
            </div>
            <div className="card mb-2" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                  <span className="placeholder col-5 rounded-2"></span>
                  <span className="placeholder col-5 rounded-2"></span>
                </h5>
                <p className="card-text d-flex justify-content-between placeholder-glow">
                  <span className="placeholder col-12 py-2 rounded-2"></span>
                </p>
              </div>
            </div>
            <div className="card mb-2" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                  <span className="placeholder col-5 rounded-2"></span>
                  <span className="placeholder col-5 rounded-2"></span>
                </h5>
                <p className="card-text d-flex justify-content-between placeholder-glow">
                  <span className="placeholder col-12 py-2 rounded-2"></span>
                </p>
              </div>
            </div>
            <div className="card mb-2" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                  <span className="placeholder col-5 rounded-2"></span>
                  <span className="placeholder col-5 rounded-2"></span>
                </h5>
                <p className="card-text d-flex justify-content-between placeholder-glow">
                  <span className="placeholder col-12 py-2 rounded-2"></span>
                </p>
              </div>
            </div>
            <div className="card mb-2" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                  <span className="placeholder col-5 rounded-2"></span>
                  <span className="placeholder col-5 rounded-2"></span>
                </h5>
                <p className="card-text d-flex justify-content-between placeholder-glow">
                  <span className="placeholder col-12 py-2 rounded-2"></span>
                </p>
              </div>
            </div>
            <div className="card mb-2" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                  <span className="placeholder col-5 rounded-2"></span>
                  <span className="placeholder col-5 rounded-2"></span>
                </h5>
                <p className="card-text d-flex justify-content-between placeholder-glow">
                  <span className="placeholder col-12 py-2 rounded-2"></span>
                </p>
              </div>
            </div>
            <div className="card mb-2" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                  <span className="placeholder col-5 rounded-2"></span>
                  <span className="placeholder col-5 rounded-2"></span>
                </h5>
                <p className="card-text d-flex justify-content-between placeholder-glow">
                  <span className="placeholder col-12 py-2 rounded-2"></span>
                </p>
              </div>
            </div>
            <div className="card mb-2" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                  <span className="placeholder col-5 rounded-2"></span>
                  <span className="placeholder col-5 rounded-2"></span>
                </h5>
                <p className="card-text d-flex justify-content-between placeholder-glow">
                  <span className="placeholder col-12 py-2 rounded-2"></span>
                </p>
              </div>
            </div>
            <div className="card mb-2" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                  <span className="placeholder col-5 rounded-2"></span>
                  <span className="placeholder col-5 rounded-2"></span>
                </h5>
                <p className="card-text d-flex justify-content-between placeholder-glow">
                  <span className="placeholder col-12 py-2 rounded-2"></span>
                </p>
              </div>
            </div>
          </>
        )}
      </div>

      {selectedRow && (
        <Modal
          size="lg"
          backdrop="static"
          centered
          onHide={() => {
            setShowNoteModal(false);
            setSelectedRow(null);
          }}
          show={showNoteModal}
        >
          <Modal.Header className="p-0 py-2 px-3" closeButton>
            Note
          </Modal.Header>
          <Modal.Body>
            <form id="studentNoteForm" onSubmit={handleAddNote}>
              <input type="hidden" name="id" value={selectedRow?.studentId} />
              <textarea
                name="note"
                value={selectedRow?.note}
                id=""
                placeholder="Enter Note..."
                className="form-control"
              ></textarea>
            </form>
          </Modal.Body>
          <Modal.Footer className="p-0 py-2 px-3">
            <button
              onClick={() => {
                setShowNoteModal(false);
                setSelectedRow(null);
              }}
              className="btn btn-outline-primary"
            >
              Close
            </button>
            <button form="studentNoteForm" className="btn btn-outline-danger">
              Save Changes
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
}

export default StudentDetailsList;
